import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";
import { getDeviceTypePatients } from "app/services/dashboard/deviceTypePatientService";
import { downloadFile } from "app/utils/file";

import LoadingModal from "components/common/loading/LoadingModal";
import React, { useState } from "react";
import { showErrorToast, showSuccessToast } from "utils/toast";

const DeviceTypePatient = ({ currentUser }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);

      const response = await getDeviceTypePatients();
      if (response.error) {
        throw response.error;
      }

      if (response.data && response.filename) {
        const { filename } = response;
        downloadFile(response, filename);
        showSuccessToast("Device Type Patients downloaded successfully.");
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => handleDownload()}
        startIcon={<Download />}
      >
        Download Device Patient Count
      </Button>

      {isDownloading && (
        <LoadingModal open={isDownloading} loadingText="Downloading..." />
      )}
    </>
  );
};

export default DeviceTypePatient;
